<template>
    <div>
        <topnav :toptype="toptype" ></topnav>
        <div class="response" style="min-height: calc(100vh - 240px - 175px);">
            <div class="" v-if="config">
                <el-image class="topimg" :src="config.cyfw_pic | addurl" fit="fill"></el-image>
            </div>
            <!-- <div class="nav-list  marginauto conwidth animated slideInRight box"> 
                <template v-for="(item,index) in cartlist">
                    <div class="nav-item" @click="jump(item.id)" style="">
                        <div class="box_cent" :class="ttta==item.id?'sty':''">{{item.name}}</div>
                    </div>
                </template>

                <div @click="jump(2)" style="width: 33.33%;display: flex;align-items: center;justify-content: center;">
                    <div class="box_cent" :class="ttta==2?'sty':''">知识产权</div>
                </div>
                <div @click="jump(3)" style="width: 33.33%;display: flex;align-items: center;justify-content: center;">
                    <div class="box_cent" :class="ttta==3?'sty':''">政策服务</div>
                </div>
                <div @click="jump(4)" style="width: 33.33%;display: flex;align-items: center;justify-content: center;">
                    <div class="box_cent" :class="ttta==4?'sty':''">技术服务</div>
                </div>
            </div>
            <div class="marginauto conwidth nav-list animated slideInRight  ">
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                    <template v-for="(item,index) in cartlist">
                        <el-menu-item :index="item.id">{{item.name}}</el-menu-item>
                    </template>
                </el-menu>
            </div> -->
            <div>

            </div>
            <div class="marginauto conwidth nav-list animated slideInRight  ">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <template v-for="(item,index) in cartlist">
                        <el-tab-pane :label="item.name" :name="'tt'+item.id"> </el-tab-pane>
                    </template>
                </el-tabs>
            </div>
            <div class="marginauto conwidth conall animated slideInRight" style="padding-top: 10px;">
                <template v-for="(item,index) in cartlist">
                    <div class="flex justify-center align-center bigone" :id="'tt'+item.id">
                        <div class="" style="position: relative;">
                            <el-image class="leftimg" :src="item.image | addurl" fit="fill"></el-image>
                            <div class="flex justify-start align-center flex-direction" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;padding-top: 60px;">
                                <div class="text-white text-center" style="font-size: 40px;font-weight: 600;">
                                    {{item.name}}
                                </div>
                                <div @click="tolist(item.id)" class="more pointer">更多→</div>
                            </div>
                        </div>
                        <div class="r-list-view flex-sub  rightall">
                            <template v-for="(citem,cindex) in item.list">
                                <div class="r-item-view bg-white lione pointer hvr-float" @click="todetail(citem.id)" :class="index < 3 ? 'mthree':''">
                                    <div class="lcon">
                                        <div class="text-cut ctext1">{{citem.name}}</div>
                                        <div class="text-cut2 ctext2">{{citem.title}}</div>
                                        <!-- <div class="text-cut ctext3">服务商：{{citem.company}}</div> -->
                                        <div class="text-cut ctext3" style="height:26px;"></div>
                                        <div class="flex justify-between align-center margin-top">
                                            <div class="pointer dbtn">详情</div>
                                            <!-- <div class="ctext4">咨询{{citem.question_number}}</div> -->
                                        </div>
                                    </div>
                                </div>
                            </template>
                           <!-- <template v-for="(citem,cindex) in item.list">
                                <div class="r-item-view bg-white lione pointer hvr-float" @click="todetail(item.id)" :class="index < 3 ? 'mthree':''">
                                    <div class="lcon">
                                        <div class="text-cut ctext1">{{citem.name}}</div>
                                        <div class="text-cut2 ctext2">{{citem.title}}</div>
                                        <div class="text-cut ctext3" style="height:26px;"></div>
                                        <div class="flex justify-between align-center margin-top">
                                            <div class="pointer dbtn">详情</div>
                                        </div>
                                    </div>
                                </div>
                            </template> -->

                        </div>
                        <div class="rightall response flex justify-center align-center" v-if="!item.list.length">
                            <el-empty :description="'暂无'+item.name"></el-empty>
                        </div>
                    </div>
                </template> 
            </div>
        </div>
 
        <!-- <el-backtop></el-backtop> -->

    </div>
</template>
<script>
export default {
    data() {
        return {
            toptype: 4,
            listone: [],
            listtwo: [],
            listthree: [],
            listfour: [],
            config: "",
            ttta: 1,
            activeName: "tt36",
            cartlist: [
                // {
                //     id: 1,
                //     name: "工商财税",
                //     img: "/static/assets/images/index/img1.png",
                // },
                // {
                //     id: 2,
                //     name: "知识产权",
                //     img: "/static/assets/images/index/img2.png",
                // },
                // {
                //     id: 3,
                //     name: "政策服务",
                //     img: "/static/assets/images/index/img3.png",
                // },
                // {
                //     id: 4,
                //     name: "技术服务",
                //     img: "/static/assets/images/index/img5.png",
                // },
                // {
                //     id: 5,
                //     name: "法律服务",
                //     img: "/static/assets/images/index/img5.png",
                // },
                // {
                //     id: 6,
                //     name: "政策服务",
                //     img: "/static/assets/images/index/img5.png",
                // },
                // {
                //     id: 7,
                //     name: "资质认定",
                //     img: "/static/assets/images/index/img5.png",
                // },
                // {
                //     id: 8,
                //     name: "营销推广",
                //     img: "/static/assets/images/index/img5.png",
                // },
                // {
                //     id: 9,
                //     name: "人力资源",
                //     img: "/static/assets/images/index/img5.png",
                // },
                // {
                //     id: 10,
                //     name: "创业支持",
                //     img: "/static/assets/images/index/img5.png",
                // },
            ],
        };
    },
    watch: {
        activeName(e) {
            console.log(e);
            this.goAnchor("#" + e);
        },
    },
    methods: {
        handleClick(e) {
            console.log(e);
        },
        goAnchor(selector) {
            var anchor = this.$el.querySelector(selector); // 获取元素
            console.log(anchor);
            if (anchor) {
                setTimeout(() => {
                    // 页面没有渲染完成时是无法滚动的，因此设置延迟
                    anchor.scrollIntoView({ behavior: "smooth" }); // js的内置方法，可滚动视图位置至元素位置
                });
            }
        },
        jump(val) {
            // 点击跳转的方法 val 你定义的需要跳转的标签id 此方法可以根据自己的实际情况编辑
            this.ttta = val;
            this.goAnchor("#tt" + val);
        },

        todetail(e) {
            this.$router.push({ path: "/riskdetail", query: { id: e } });
        },
        todetail1(e) {
            this.$router.push({ path: "/techdetail", query: { id: e } });
        },
        tolist(e) {
            this.$router.push({ path: "/risklist", query: { type: e } });
        },
        tolist1(e) {
            this.$router.push({ path: "/technics" });
        },
        getstartlist(type) {
            var data = {
                start: 1,
                page_size: 6,
                type: type,
            };
            this.$api.index.start_list(data).then((response) => {
                // console.log(response)
                if (type == 1) {
                    this.listone = response.data;
                } else if (type == 2) {
                    this.listtwo = response.data;
                } else if (type == 3) {
                    this.listthree = response.data;
                } else if (type == 4) {
                    this.listfour = response.data;
                }
            });
        },
        getlist() {
            var data = {
                start: 1,
                page_size: 6,
                // first_id: this.sortid,
                // second_id: this.sorttwoid,
                // keyword: this.keyword
            };
            this.$api.index.tech_list(data).then((res) => {
                console.log(res.data, 123);
                this.listfour = res.data;
            });
        },
        getcyfulist() {
            this.$api.index.getcyfulist().then((response) => {
                console.log(response);
                this.cartlist = response.data;
            });
        },
    },
    created() {
        this.getcyfulist();
        this.config = JSON.parse(localStorage.getItem("config"));
        window.addEventListener(
            "scroll",
            function (e) {
                let scTop = document.documentElement.scrollTop;
                // console.log(scTop);
            },
            false
        );

    },
};
</script>
<style>
.nav-list .el-tabs__item {
    height: 80px;
    line-height: 80px;
    font-size: 18px;
    padding: 0px 25px;
}
.nav-list .el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: rgba(0, 0, 0, 0);
    z-index: 1;
}

.nav-list .el-tabs__active-bar {
    bottom: 4px;
    background-color: #1759d8;
}

.nav-list .el-tabs__item.is-active {
    color: #1759d8;
}
.nav-list .el-tabs__item:hover {
    color: #1759d8;
}
</style>
<style scoped>
.mthree {
    margin-bottom: 10px;
}
.lione {
    border-radius: 3px;
    width: 350px;
    height: 244px;
}
.dbtn {
    width: 120px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    color: #fff;
    background-color: #ffab18;
    border-radius: 4px;
    font-size: 18px;
}
.topimg {
    width: 100%;
    height: 500px;
}
.conall {
    padding: 40px 0;
}
.bigone {
    background: #f4f4f4;
    margin-bottom: 25px;
}
.leftimg {
    width: 234px;
    height: 528px;
    display: block;
}
.rightall {
    padding: 15px 10px;
    height: 498px;
}
.lcon {
    margin: 30px 30px 0 30px;
}
.ctext1 {
    color: #262626;
    font-size: 21px;
    margin-bottom: 12px;
}
.ctext2 {
    color: #9c9c9c;
    font-size: 18px;
    height: 52px;
    margin-bottom: 15px;
}
.ctext3 {
    color: #262626;
    font-size: 20px;
}
.ctext4 {
    color: #bbbbbb;
    font-size: 17px;
}
.more {
    width: 120px;
    height: 34px;
    border-radius: 4px;
    border: solid 1px #ffffff;
    text-align: center;
    line-height: 34px;
    font-size: 18px;
    color: #fff;
    margin-top: 30px;
}
.box {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.box_cent {
    width: 36%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 100%;
    transition: 1s;
    height: 70px;
    border-bottom: 2px solid #fff;
}
.sty {
    border-bottom: 2px solid #1759d8;
    /* color: #fff; */
}
.nav-list .nav-item {
    width: 33.33%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.r-list-view {
    display: flex;
    flex-wrap: wrap;
}
.r-list-view .r-item-view {
    margin-right: 10px;
}
.r-list-view .r-item-view:nth-child(3n) {
    margin-right: 0px;
}
</style>


// WEBPACK FOOTER //
// risk.vue?ca656002